/*
  Generic rail: binds a horizontally scrolling list to a progress bar and
  optional prev / next buttons. One job — used by every carousel that isn't
  the sport rail.

    [data-ps-rail-root]
      [data-ps-rail]          the scrolling list
      [data-ps-rail-bar]      progress bar (reads --w and --x)
      [data-ps-rail-prev] / [data-ps-rail-next]   optional buttons
*/
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.psRailReady) return;
    var rail = root.querySelector('[data-ps-rail]');
    if (!rail) return;
    root.dataset.psRailReady = '1';
    var bar = root.querySelector('[data-ps-rail-bar]');
    var prev = root.querySelector('[data-ps-rail-prev]');
    var next = root.querySelector('[data-ps-rail-next]');

    function update() {
      var max = rail.scrollWidth - rail.clientWidth;
      var scrollable = max > 2;
      root.classList.toggle('is-static', !scrollable);
      if (bar) {
        var w = scrollable ? Math.max(0.12, rail.clientWidth / rail.scrollWidth) : 1;
        var pos = scrollable ? rail.scrollLeft / max : 0;
        bar.style.setProperty('--w', (w * 100) + '%');
        bar.style.setProperty('--x', ((1 - w) / w * pos * 100) + '%');
      }
      if (prev) prev.disabled = !scrollable || rail.scrollLeft <= 2;
      if (next) next.disabled = !scrollable || rail.scrollLeft >= max - 2;
    }

    function page(dir) {
      var item = rail.firstElementChild;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      var step = item ? item.getBoundingClientRect().width + gap : rail.clientWidth;
      rail.scrollBy({ left: dir * step, behavior: 'smooth' });
    }

    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });
    update();
  }

  function boot() { document.querySelectorAll('[data-ps-rail-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
